import * as React from "react";
import "../ContactUs/Style.css";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Textarea from '@mui/joy/Textarea';
import Box from '@mui/joy/Box';
import { toast } from "react-toastify";
import SaveAltTwoToneIcon from "@mui/icons-material/SaveAltTwoTone";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ContactUsModal from "../../Assets/contactUs-modal.png";
import { useNavigate } from "react-router-dom";
import LabelInput from "../../Components/LabelInputFields/Index";
import Layout from "../../Components/Layout/Layout";
import { APIUrlEICI, APIUrlThree, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
export default function ContactUs() {
  const [contactDetails, setContactDetails] = React.useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    joDepartments: "",
    department: "",
    requestType: "",
    uploadFile: "",
    message: "",
  })
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '563px',
    height: '532px',
    bgcolor: '#fff',
    border: '2px solid #fff',
    boxShadow: 24,
    p: 4,
    borderRadius: '17px'

  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  function isValidEmail(emailAddress) {
    return emailRegex.test(emailAddress);
  }
  const validateFields = () => {
    if (
      !contactDetails?.firstName ||
      contactDetails?.firstName?.trim() === ""
    ) {
      toast.error("Please Enter First Name");
      return false;
    }
    if (!contactDetails?.lastName || contactDetails?.lastName?.trim() === "") {
      toast.error("Please Enter Last Name");
      return false;
    }
    if (
      !contactDetails?.emailAddress ||
      contactDetails?.emailAddress?.trim() === ""
    ) {
      toast.error("Please Enter Email Address");
      return false;
    }
    if (!isValidEmail(contactDetails?.emailAddress)) {
      toast.error("Please Enter Valid Email");
      return false;
    }
    if (
      !isValidEmail(contactDetails?.emailAddress) ||
      contactDetails?.emailAddress?.trim() === ""
    ) {
      toast.error("Please Enter Email Address");
      return false;
    }
    if (!contactDetails?.joDepartments) {
      toast.error("Please Enter JO Deparment");
      return false;
    }
    if (!contactDetails?.message) {
      toast.error("Please Select Question or Message");
      return false;
    }
    return true;
  };

  const SubmitContact = (e) => {
    if (!validateFields()) return;
    setLoading(true);
    const data = {};
    data.first_name = contactDetails?.firstName;
    data.last_name = contactDetails?.lastName;
    data.email = contactDetails?.emailAddress;
    data.jo_department = contactDetails?.joDepartments;
    data.department = "";
    data.request_type = "Other";
    data.question_message = contactDetails?.message;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization":APIUrlToken()
      },
      url: `${APIUrlEICI()}/contact-us`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        setContactDetails({
          firstName: "",
          lastName: "",
          emailAddress: "",
          joDepartments: "",
          department: "",
          requestType: "",
          uploadFile: "",
          message: "",
        });
        handleOpen();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const backToDashboardModal = () => {
    navigate('/dashboard');
    handleClose();
  }
  return (
    <>
      <Layout>
     
      {loading ? <Loader /> : null}
      <section className="ContactUsScreen-main-container">
        
        <div className="ContactUsScreen-container-outter">
        <div className="ContactUsScreen-heading">
          <h3>Contact Us </h3>
          <p>We’re excited to help and eager to hear from you</p>
        </div>
          <div className="ContactUsScreen-container">
            <div className="ContactUsScreen-flex-container">
              <div className="ContactUsScreen-child-container">
                <label htmlFor="" className="ContactUsScreen-lables">
                  First Name
                </label>
                <span className="mandatoryfields">*</span>
                <LabelInput
                  onChange={(e) => {
                    const inputvalue = e?.target?.value;
                    setContactDetails({
                      ...contactDetails,
                      firstName: inputvalue,
                    });
                  }}
                  value={contactDetails?.firstName}
                />
              </div>
              <div className="ContactUsScreen-child-container">
                <label htmlFor="" className="ContactUsScreen-lables">
                  Last Name
                </label>
                <span className="mandatoryfields">*</span>
                <LabelInput
                  onChange={(e) => {
                    const inputvalue = e?.target?.value;
                    setContactDetails({
                      ...contactDetails,
                      lastName: inputvalue,
                    });
                  }}
                  value={contactDetails?.lastName}
                />
              </div>
            </div>
            <div className="ContactUsScreen-flex-container">
              <div className="ContactUsScreen-child-container">
                <label htmlFor="" className="ContactUsScreen-lables">
                  Email Address
                </label>
                <span className="mandatoryfields">*</span>
                <LabelInput
                  onChange={(e) => {
                    const inputvalue = e?.target?.value;
                    setContactDetails({
                      ...contactDetails,
                      emailAddress: inputvalue,
                    });
                  }}
                  value={contactDetails?.emailAddress}
                />
              </div>

              <div className="ContactUsScreen-child-container">
                <label htmlFor="" className="ContactUsScreen-lables">
                JO Department
                </label>
                <span className="mandatoryfields">*</span>
                <LabelInput
                  onChange={(e) => {
                    const inputvalue = e?.target?.value;
                    setContactDetails({
                      ...contactDetails,
                      joDepartments: inputvalue,
                    });
                  }}
                  value={contactDetails?.joDepartments}
                />
              </div>

              {/* <div className="ContactUsScreen-child-container">
                <label htmlFor="" className="ContactUsScreen-lables">
                  JO Department
                </label>
                <span className="mandatoryfields">*</span>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                  <Select
                    className="ContactUsScreen-dropdown"
                    onChange={(e) => {
                      const inputvalue = e?.target?.value;
                      setContactDetails({
                        ...contactDetails,
                        joDepartments: inputvalue,
                      });
                    }}
                    value={contactDetails?.joDepartments}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    {Departments?.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item} className="mn-events">
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div> */}
            </div>
          <div className="ContactUsScreen-child-container">
            <label  className="ContactUsScreen-lables">
              Question or Message
            </label>
            <div className="contactusTextarea">
              <Textarea
                className="ContactUsScreen-lables-text-field-area"
                value={contactDetails?.message}
                aria-label="minimum height"
                minRows={3}
                onChange={(e) => {
                  const inputvalue = e?.target?.value;
                  setContactDetails({ ...contactDetails, message: inputvalue });
                }}
              />
            </div>
            </div>
            <div className="SUBMITbutton-div">
              <Stack spacing={2} direction="row">
                <Button
                  className="ContactUs-SUBMIT-button"
                  variant="contained"
                  onClick={SubmitContact}
                >
                  <SaveAltTwoToneIcon />
                  SUBMIT
                </Button>
              </Stack>
            </div>
          </div>
        </div>
      </section>
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="box-contactus-modal">
            <div className="modal-img-section">
              <img src={ContactUsModal} alt="modal-image" />

              <Typography id="modal-modal-description" className="content-modal-contactus">
                Thank you for contacting us.
              </Typography>

              <button className="button-modal-contactUs" onClick={() => backToDashboardModal()}>
                Back to Dashboard
              </button>
            </div>
          </Box>
        </Modal>
      </div>
      </Layout>
    </>
  );
}